export default {"src":"/_next/static/media/content.85c7bff9.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};